module.exports = __webpack_public_path__ + "media/stylesheets/images/media/media_mobile_folk-18f69911c4caff73b8c4d08102dc8d36.png";